(function () {
  const dropdowns = document.querySelectorAll(".lyfe-dropdown");

  function closeAll() {
    dropdowns.forEach(d => {
      d.classList.remove("is-open");
      const btn = d.querySelector(".lyfe-nav-link");
      if (btn) btn.setAttribute("aria-expanded", "false");
    });
  }

  dropdowns.forEach(d => {
    const btn = d.querySelector(".lyfe-nav-link");
    if (!btn) return;

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const isOpen = d.classList.contains("is-open");
      closeAll();
      if (!isOpen) {
        d.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });

  document.addEventListener("click", (e) => {
    const inside = e.target.closest(".lyfe-dropdown");
    if (!inside) closeAll();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });
})();
